import React, { useRef } from 'react'
import { Box, Typography, Stack } from '@mui/material'
import ExcelIcon from '@/assets/Excel Icon.svg'
import UploadIcon from '@/assets/upload.svg'
import { useAppTheme } from '@/theme/ThemeContext'

interface Step1UploadProps {
  selectedFile: File | null
  onFileChange: (file: File | null) => void
}

export const Step1Upload: React.FC<Step1UploadProps> = ({ selectedFile, onFileChange }) => {
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0] || null
    onFileChange(file)
  }

  const handleUploadClick = () => {
    fileInputRef.current?.click()
  }

  return (
    <Box
      onClick={handleUploadClick}
      sx={{
        height: '500px',
        bgcolor: isDarkMode ? '#061F43A1' : '#F8FAFC',
        backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='16' ry='16' stroke='%23${(isDarkMode ? '1D325A' : '72A4EB').replace('#', '')}' stroke-width='4' stroke-dasharray='20%2c 30' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
        borderRadius: '16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        cursor: 'pointer',
        transition: 'all 0.2s',
        '&:hover': {
          borderColor: '#3B82F6',
          bgcolor: isDarkMode ? 'rgba(59, 130, 246, 0.05)' : 'rgba(59, 130, 246, 0.02)',
        },
      }}
    >
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
        accept=".csv, .xlsx"
      />
      <Box sx={{ 
        mb: 1, 
        bgcolor: isDarkMode ? '#091327' : 'transparent',
        p: 2,
        borderRadius: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <img 
          src={ExcelIcon} 
          alt="Excel" 
          style={{ 
            width: 48, 
            height: 48,
            filter: isDarkMode 
              ? 'brightness(0) invert(87%) sepia(15%) saturate(884%) hue-rotate(183deg) brightness(101%) contrast(102%)' 
              : 'none'
          }} 
        />
      </Box>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ color: isDarkMode ? '#BBD7FF' : '#003F61' }}>
        {!selectedFile && (
          <img 
            src={UploadIcon} 
            alt="Upload" 
            style={{ 
              width: 15, 
              height: 20,
              filter: isDarkMode ? 'brightness(0) invert(1)' : 'none'
            }} 
          />
        )}
        <Typography sx={{ fontSize: '15px', fontWeight: selectedFile ? 700 : 500, fontFamily: 'Rubik' , paddingRight: selectedFile ? 0 : 0.5}}>
          {selectedFile ? selectedFile.name : 'העלאת קובץ .csv / .xlsx'}
        </Typography>
      </Stack>
    </Box>
  )
}
